import { MenuItem } from '../types';
import MenuCard from './MenuCard';

interface MenuGridProps {
  items: MenuItem[];
  onEdit: (item: MenuItem) => void;
  onToggleAvailable: (item: MenuItem) => void;
  onToggleActive: (item: MenuItem) => void;
}

const MenuGrid = ({
  items,
  onEdit,
  onToggleAvailable,
  onToggleActive,
}: MenuGridProps) => {
  return (
    <div className="grid grid-cols-1 gap-4 p-5 sm:px-7 md:hidden">
      {items.map((item) => (
        <MenuCard
          key={item.id}
          item={item}
          onEdit={onEdit}
          onToggleAvailable={onToggleAvailable}
          onToggleActive={onToggleActive}
        />
      ))}
    </div>
  );
};

export default MenuGrid;